export enum MewsTeam {
    Accounting = 'Accounting',
    /** @deprecated - use GuestProfiles team instead */
    Accounts = 'Accounts',
    ActivationExperience = 'ActivationExperience',
    Analytics = 'Analytics',
    Billing = 'Billing',
    Connectivity = 'Connectivity',
    Distribution = 'Distribution',
    EcosystemExperience = 'EcosystemExperience',
    Expansion = 'Expansion',
    FinancialServices = 'FinancialServices',
    GroupsEvents = 'GroupsEvents',
    GuestExperience = 'GuestExperience',
    GuestProfiles = 'GuestProfiles',
    Infrastructure = 'Infrastructure',
    Jarvis = 'Jarvis',
    MultiProperty = 'MultiProperty',
    Multicurrency = 'Multicurrency',
    PaymentExperience = 'PaymentExperience',
    PaymentPayout = 'PaymentPayout',
    PaymentProcessing = 'PaymentProcessing',
    /** @deprecated - choose multi property/revenue services/spaces domain */
    Pricing = 'Pricing',
    Productivity = 'Productivity',
    Reservations = 'Reservations',
    RevenueServices = 'RevenueServices',
    /** @deprecated - choose multi property/revenue services/spaces domain */
    Services = 'Services',
    Spaces = 'Spaces',
    Tooling = 'Tooling',
    Users = 'Users',
}
